import gql from 'graphql-tag';

const GET_SALESFORCE_OPPORTUNITY_PROPOSAL_NUMBER = gql`
  query GetSalesforceOpportunityProposalNumber($salesforceOpportunityId: String!) {
    getSalesforceOpportunityProposalNumber(
      salesforceOpportunityId: $salesforceOpportunityId
    )
  }
`;

export default GET_SALESFORCE_OPPORTUNITY_PROPOSAL_NUMBER;
